import { ActionIcon, Loader, createTheme } from '@mantine/core';

export const myTheme = createTheme({
    primaryColor: 'ip-blue',
    colors: {
        'ip-blue': [
            '#F7FBFE', // lightest shade [0]
            '#E5F2FB',
            '#CCE5F7',
            '#B2D8F3',
            '#99CBEF',
            '#80BEEB',
            '#1A77B0', // target color [6]
            '#155D89',
            '#104362',
            '#0B2A3C'  // darkest shade [9]
        ],
        'ip-cyan': [
            '#EBF9FA', // lightest shade [0]
            '#D7F3F5',
            '#AAE4E8',
            '#7DD4DB',
            '#3CB3C0', // your target color [4]
            '#2E9AA6',
            '#24808B',
            '#1B6670',
            '#134C54',
            '#0B3238'  // darkest shade [9]
        ],
        'ip-green': [
            '#EFF8F0', // lightest shade [0]
            '#DFF1E0',
            '#B5E1B8',
            '#8BD090',
            '#64BB6A', // your target color [4]
            '#4FA554',
            '#428B46',
            '#357137',
            '#275728',
            '#1A3D1B'  // darkest shade [9]
        ]
    },
    defaultRadius: 'md',
    focusRing: 'auto',
    fontFamily: 'Open Sans, sans-serif',
    headings: { fontFamily: 'Open Sans, sans-serif' },
    components: {
        ActionIcon: ActionIcon.extend({
            defaultProps: {
                variant: 'subtle',
            },
        }),
        Loader: Loader.extend({
            defaultProps: {
                type: 'bars',
            },
        }),
    },
});